export default "__VITE_ASSET__Dr$g9KdQ__"